import { render } from "./CategorySettings.vue?vue&type=template&id=2f9620d7"
import script from "./CategorySettings.vue?vue&type=script&lang=js"
export * from "./CategorySettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__